import { __awaiter } from "tslib";
import { useAuth } from '@lusha/auth-client-sdk';
import AppDispatcher from '@reducers/app/dispatcher';
import BulkDispatcher from '@reducers/bulk/dispatcher';
import CompanyDispatcher from '@reducers/company/dispatcher';
import { selectCurrentCompanyKey } from '@reducers/company/selectors';
import ContactDispatcher from '@reducers/contact/dispatcher';
import FlagsDispatcher from '@reducers/flags/dispatcher';
import { useAppDispatch } from '@reducers/index';
import { actions as searchCompanyActions } from '@reducers/searchCompany/reducer';
import SettingsDispatcher from '@reducers/settings/dispatcher';
import { store } from '@reducers/store';
import UserDispatcher from '@reducers/user/dispatcher';
import dayjs from 'dayjs';
import _ from 'lodash';
import { useEffect } from 'react';
import { useAsyncFetch } from 'react-hooks-async-handlers';
import { messaging } from './lib/messaging';
import { SEARCH_STATUS } from './utils/constants';
function AppInt(props) {
    const { children } = props;
    const auth = useAuth();
    const dispatch = useAppDispatch();
    useAsyncFetch(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(AppDispatcher.install());
    }));
    useEffect(() => {
        function onMessage(event) {
            var _a, _b, _c;
            if (!_.isObject(event.data))
                return null;
            const { type, payload } = event.data;
            console.log(dayjs().toISOString(), 'received event', type, payload, event);
            switch (type) {
                case 'SETTINGS': {
                    dispatch(SettingsDispatcher.load(payload));
                    break;
                }
                case 'PAGE': {
                    dispatch(AppDispatcher.setPage(payload));
                    break;
                }
                case 'FLAG/PULL': {
                    dispatch(FlagsDispatcher.set(payload));
                    break;
                }
                case 'PARSER/RESULT': {
                    const result = payload || {};
                    dispatch(AppDispatcher.actions.setParserResult(result));
                    break;
                }
                case 'SEARCH/RESULT': {
                    const { parser, result, type, invalidated } = payload || {};
                    // dispatch(AppDispatcher.actions.setParserResult(parser))
                    if (type === 'contact') {
                        if (invalidated) {
                            dispatch(ContactDispatcher.actions.setInvalidateStatus(invalidated));
                        }
                        else {
                            dispatch(ContactDispatcher.setSearchResult(result));
                        }
                    }
                    if (type === 'bulk') {
                        if (invalidated) {
                            dispatch(BulkDispatcher.actions.setInvalidateStatus(invalidated));
                            break;
                        }
                        if (result) {
                            dispatch(BulkDispatcher.setSearchResult(result));
                            dispatch(BulkDispatcher.setSearchStatus(SEARCH_STATUS.RESOLVED));
                            root.savedTab.setShouldFetchContactsAfterBulkSearch(true);
                            if (app.firstSearch) {
                                app.setFirstSearch(false);
                            }
                        }
                    }
                    if (type === 'company') {
                        if (invalidated) {
                            dispatch(CompanyDispatcher.actions.setInvalidateStatus(invalidated));
                            break;
                        }
                        if (result) {
                            const appContext = store.getState().app.appContext;
                            const previousCompanyKey = selectCurrentCompanyKey(store.getState());
                            dispatch(CompanyDispatcher.setSearchEmployeesResult(result));
                            const companyKey = ((_b = (_a = result.company) === null || _a === void 0 ? void 0 : _a.company_lid) === null || _b === void 0 ? void 0 : _b.toString()) || ((_c = result.company) === null || _c === void 0 ? void 0 : _c.fqdn);
                            if (companyKey && previousCompanyKey && previousCompanyKey !== companyKey) {
                                dispatch(searchCompanyActions.setIsFirstSearch({ context: appContext, isFirstSearch: true }));
                            }
                            if (!_.isEmpty(result.company)) {
                                dispatch(searchCompanyActions.setResultCompany({ context: appContext, company: result.company }));
                            }
                        }
                    }
                    break;
                }
                case 'CONTENT/READY': {
                    dispatch(AppDispatcher.actions.setIsContentScriptReady());
                    break;
                }
                case 'AUTH/LOGOUT': {
                    dispatch(UserDispatcher.logout());
                    auth.logout();
                    break;
                }
                default:
                    break;
            }
        }
        window.addEventListener('message', onMessage, false);
        messaging.sendMessage('APP_INIT');
        messaging.sendMessage('SETTINGS_READY'); // support for plugin 10.5+
        return () => {
            // doesn't suppose to happen, but there is bug with 2 mounts
            window.removeEventListener('message', onMessage);
        };
    }, []);
    return children;
}
export default AppInt;
